module.exports = __webpack_public_path__ + "static/media/DNFT.94534215.png";